import React from 'react';
import SaleForce from 'components/Tvendo/Sale/DataMaster/SaleForce/List.js';

export default function () {
  return <SaleForce />;
}
